// import React from 'react';
// import styled from 'styled-components';
// import { AlertCircle, ArrowRight } from 'lucide-react';

// const ChallengeCard = ({ data, index }) => {
//     // Dynamic themes based on index
//     const colors = ["#ef4444", "#3b82f6", "#10b981", "#f59e0b", "#8b5cf6"];
//     const themeColor = colors[index % colors.length];

//     return (
//         <StyledCard themeColor={themeColor}>
//             <div className="flip-card">
//                 <div className="flip-card-inner">

//                     {/* FRONT SIDE */}
//                     <div className="flip-card-front">
//                         <div className="content-padding">
//                             <div className="icon-box">
//                                 <AlertCircle size={32} color={themeColor} />
//                             </div>
//                             <h3 className="heading">{data.heading}</h3>
//                             <div className="divider"></div>
//                             <div className="problem-section">
//                                 <span className="label">THE PROBLEM</span>
//                                 <p className="problem-text">{data.problem}</p>
//                             </div>
//                             <div className="flip-hint">
//                                 <span>Hover to see impact</span>
//                                 <ArrowRight size={14} />
//                             </div>
//                         </div>
//                     </div>

//                     {/* BACK SIDE */}
//                     <div className="flip-card-back">
//                         <div className="content-padding">
//                             <div className="leads-to">
//                                 <span className="label">WHAT IT LEADS TO</span>
//                                 <ul>
//                                     {data.leadsTo.map((point, i) => (
//                                         <li key={i}>{point}</li>
//                                     ))}
//                                 </ul>
//                             </div>

//                             <div className="hidden-cost-box">
//                                 <span className="label">HIDDEN COST</span>
//                                 <p>{data.hiddenCost}</p>
//                             </div>

//                             <div className="back-glow"></div>
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </StyledCard>
//     );
// };

// const StyledCard = styled.div`
//   padding: 15px;

//   .flip-card {
//     background-color: transparent;
//     width: 100%;
//     height: 550px; /* Increased Height */
//     perspective: 1000px;
//   }

//   .flip-card-inner {
//     position: relative;
//     width: 100%;
//     height: 100%;
//     text-align: left;
//     transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
//     transform-style: preserve-3d;
//   }

//   .flip-card:hover .flip-card-inner {
//     transform: rotateY(180deg);
//   }

//   .flip-card-front, .flip-card-back {
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     -webkit-backface-visibility: hidden;
//     backface-visibility: hidden;
//     border-radius: 30px;
//     border: 1px solid rgba(255, 255, 255, 0.1);
//     overflow: hidden;
//   }

//   .flip-card-front {
//     background-color: #0f0f11;
//     color: white;
//     display: flex;
//     flex-direction: column;
//   }

//   .flip-card-back {
//     background-color: #121214;
//     color: white;
//     transform: rotateY(180deg);
//     display: flex;
//     flex-direction: column;
//   }

//   .content-padding {
//     padding: 40px;
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//   }

//   .icon-box {
//     margin-bottom: 30px;
//   }

//   .heading {
//     font-size: 22px;
//     font-weight: 700;
//     line-height: 1.4;
//     margin-bottom: 25px;
//     color: #fff;
//   }

//   .divider {
//     width: 50px;
//     height: 4px;
//     background-color: ${props => props.themeColor};
//     margin-bottom: 30px;
//   }

//   .label {
//     display: block;
//     font-size: 10px;
//     font-weight: 900;
//     letter-spacing: 2px;
//     color: ${props => props.themeColor};
//     margin-bottom: 15px;
//   }

//   .problem-text {
//     font-size: 16px;
//     color: #9ca3af;
//     line-height: 1.6;
//   }

//   .flip-hint {
//     margin-top: auto;
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     font-size: 12px;
//     opacity: 0.4;
//   }

//   /* Back styles */
//   ul {
//     list-style: none;
//     padding: 0;
//     margin-bottom: 40px;
//   }

//   li {
//     position: relative;
//     padding-left: 20px;
//     margin-bottom: 12px;
//     font-size: 15px;
//     color: #d1d5db;
//   }

//   li::before {
//     content: '';
//     position: absolute;
//     left: 0;
//     top: 10px;
//     width: 6px;
//     height: 6px;
//     background-color: ${props => props.themeColor};
//     border-radius: 50%;
//   }

//   .hidden-cost-box {
//     margin-top: auto;
//     padding: 20px;
//     background: rgba(255, 255, 255, 0.03);
//     border-left: 3px solid ${props => props.themeColor};
//     border-radius: 0 10px 10px 0;
//   }

//   .hidden-cost-box p {
//     font-size: 14px;
//     font-style: italic;
//     color: #9ca3af;
//   }

//   .back-glow {
//     position: absolute;
//     bottom: -50px;
//     right: -50px;
//     width: 150px;
//     height: 150px;
//     background-color: ${props => props.themeColor};
//     filter: blur(80px);
//     opacity: 0.15;
//   }
// `;

// export default ChallengeCard;










// import React from 'react';
// import styled, { keyframes } from 'styled-components';
// import { AlertTriangle, ChevronRight } from 'lucide-react';

// const ChallengeCard = ({ data, index }) => {
//     // Dynamic Neon Colors
//     const neonColors = ["#00f2ff", "#7000ff", "#ff007a", "#ccff00", "#ff8a00"];
//     const activeColor = neonColors[index % neonColors.length];

//     return (
//         <StyledCard activeColor={activeColor}>
//             <div className="card-outer">
//                 <div className="card-inner">

//                     {/* FRONT SIDE */}
//                     <div className="side front">
//                         {/* The Border Lighting Layer */}
//                         <div className="border-glow"></div>
//                         <div className="glass-base"></div>

//                         <div className="content">
//                             <div className="icon-wrapper">
//                                 <AlertTriangle size={32} color={activeColor} />
//                             </div>
//                             <h3 className="card-title">{data.heading}</h3>
//                             <div className="problem-container">
//                                 <span className="tag" style={{ color: activeColor }}>PROBLEM</span>
//                                 <p className="description">{data.problem}</p>
//                             </div>
//                             <div className="footer-hint">
//                                 <span className="pulse-dot" style={{ backgroundColor: activeColor }}></span>
//                                 HOVER TO SEE IMPACT
//                             </div>
//                         </div>
//                     </div>

//                     {/* BACK SIDE */}
//                     <div className="side back">
//                         <div className="border-glow"></div>
//                         <div className="glass-base"></div>

//                         <div className="content">
//                             <h4 className="back-title" style={{ color: activeColor }}>WORKFORCE IMPACT</h4>
//                             <ul className="leads-list">
//                                 {data.leadsTo.map((item, i) => (
//                                     <li key={i}>{item}</li>
//                                 ))}
//                             </ul>

//                             <div className="cost-footer" style={{ borderTop: `1px solid ${activeColor}44` }}>
//                                 <small style={{ color: activeColor }}>HIDDEN OPERATIONAL COST</small>
//                                 <p>{data.hiddenCost}</p>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </StyledCard>
//     );
// };

// const borderTrace = keyframes`
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// `;

// const StyledCard = styled.div`
//   padding: 20px;

//   .card-outer {
//     width: 100%;
//     height: 560px;
//     perspective: 1200px;
//   }

//   .card-inner {
//     position: relative;
//     width: 100%;
//     height: 100%;
//     transition: transform 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//     transform-style: preserve-3d;
//   }

//   .card-outer:hover .card-inner {
//     transform: rotateY(180deg);
//   }

//   .side {
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     backface-visibility: hidden;
//     border-radius: 24px;
//     overflow: hidden; /* Clips the spinning glow to the border */
//     background: transparent;
//   }

//   /* --- BORDER LIGHTING ANIMATION --- */
//   .border-glow {
//     position: absolute;
//     top: -50%;
//     left: -50%;
//     width: 200%;
//     height: 200%;
//     /* This creates the sharp neon wire effect */
//     background: conic-gradient(
//         transparent, 
//         ${props => props.activeColor} 10%, 
//         transparent 20%
//     );
//     animation: ${borderTrace} 4s linear infinite;
//     z-index: 0;
//   }

//   /* --- GLASSMORPHISM BASE --- */
//   .glass-base {
//     position: absolute;
//     inset: 2px; /* This defines the thickness of the border */
//     background: rgba(1, 1, 76, 0.8); /* Your #01014C background with transparency */
//     backdrop-filter: blur(12px);
//     border-radius: 22px;
//     z-index: 1;
//     border: 1px solid rgba(255, 255, 255, 0.05);
//   }

//   .content {
//     position: relative;
//     z-index: 2;
//     padding: 35px;
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//   }

//   .back {
//     transform: rotateY(180deg);
//   }

//   /* Typography & Elements */
//   .icon-wrapper { margin-bottom: 25px; }

//   .card-title {
//     font-size: 22px;
//     font-weight: 800;
//     color: white;
//     line-height: 1.3;
//     margin-bottom: 30px;
//     font-family: 'Syne', sans-serif;
//   }

//   .tag {
//     font-size: 10px;
//     font-weight: 900;
//     letter-spacing: 2px;
//     display: block;
//     margin-bottom: 10px;
//   }

//   .description {
//     font-size: 16px;
//     color: rgba(255, 255, 255, 0.6);
//     line-height: 1.6;
//   }

//   .footer-hint {
//     margin-top: auto;
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     font-size: 11px;
//     color: rgba(255, 255, 255, 0.3);
//     letter-spacing: 1px;
//   }

//   .pulse-dot {
//     width: 6px;
//     height: 6px;
//     border-radius: 50%;
//     animation: pulse 1.5s infinite;
//   }

//   @keyframes pulse {
//     0% { transform: scale(1); opacity: 1; }
//     50% { transform: scale(1.5); opacity: 0.5; }
//     100% { transform: scale(1); opacity: 1; }
//   }

//   /* Back Card Details */
//   .back-title {
//     font-size: 11px;
//     font-weight: 900;
//     letter-spacing: 2px;
//     margin-bottom: 25px;
//   }

//   .leads-list {
//     list-style: none;
//     padding: 0;
//   }

//   .leads-list li {
//     font-size: 15px;
//     color: rgba(255, 255, 255, 0.8);
//     margin-bottom: 15px;
//     padding-left: 20px;
//     position: relative;
//   }

//   .leads-list li::before {
//     content: "";
//     position: absolute;
//     left: 0;
//     top: 10px;
//     width: 8px;
//     height: 2px;
//     background: ${props => props.activeColor};
//   }

//   .cost-footer {
//     margin-top: auto;
//     padding-top: 20px;
//   }

//   .cost-footer small {
//     display: block;
//     font-size: 9px;
//     font-weight: 800;
//     margin-bottom: 8px;
//     letter-spacing: 1px;
//   }

//   .cost-footer p {
//     font-size: 14px;
//     font-style: italic;
//     color: rgba(255, 255, 255, 0.5);
//   }
// `;

// export default ChallengeCard;






import React from 'react';
import styled, { keyframes } from 'styled-components';
import { AlertCircle, ArrowRight } from 'lucide-react';

const ChallengeCard = ({ data, index }) => {
  const isGradient = index % 2 !== 0;
  const activeColor = isGradient ? "#818cf8" : "#38bdf8";

  return (
    <StyledCard activeColor={activeColor} isGradient={isGradient}>
      <div className="card-outer">
        <div className="card-inner">

          {/* FRONT SIDE */}
          <div className="side front">
            {/* The Border Light Logic */}
            <div className="border-light-mask"></div>
            <div className="glass-content-base"></div>

            <div className="content">
              <div className="header">
                <AlertCircle size={28} color={activeColor} />
                <span className="label" style={{ color: activeColor }}>CHALLENGE 0{index + 1}</span>
              </div>

              <h3 className="title">{data.heading}</h3>

              <div className="problem-area">
                <p className="problem-desc">{data.problem}</p>
              </div>
            </div>
          </div>

          {/* BACK SIDE */}
          <div className="side back">
            <div className="border-light-mask"></div>
            <div className="glass-content-base"></div>

            <div className="content">
              <h4 className="impact-header" style={{ color: activeColor }}>WHAT IT LEADS TO</h4>
              <ul className="impact-list">
                {data.leadsTo.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>

              <div className="cost-container" style={{ backgroundColor: `${activeColor}10` }}>
                <small style={{ color: activeColor }}>HIDDEN OPERATIONAL COST</small>
                <p>{data.hiddenCost}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </StyledCard>
  );
};

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const StyledCard = styled.div`
  padding: 15px;

  .card-outer {
    width: 100%;
    height: 400px;
    perspective: 1200px;
  }

  .card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
    transform-style: preserve-3d;
  }

  .card-outer:hover .card-inner {
    transform: rotateY(180deg);
  }

  .side {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 28px;
    overflow: hidden;
    background: #f8fafc; /* Subtle gray/blue to contrast with white section */
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  }

  /* --- THE BORDER LIGHTING (Snake Effect) --- */
  .border-light-mask {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    /* Only shows a thin slice of light */
    background: ${props => props.isGradient ? 
      `conic-gradient(
        transparent, 
        #38bdf8, 
        #818cf8, 
        transparent 15%
      )` : 
      `conic-gradient(
        transparent, 
        #38bdf8, 
        transparent 15%
      )`
    };
    animation: ${rotate} 4s linear infinite;
    z-index: 0;
  }

  /* --- THE CENTER MASK (Removes light from center) --- */
  .glass-content-base {
    position: absolute;
    inset: 2px; /* This is the border thickness (2px) for the spinning animation */
    background: linear-gradient(145deg, #f0f9ff, #e0f2fe); /* Visibly blue gradient */
    backdrop-filter: blur(20px);
    border-radius: 26px;
    z-index: 1;
    border: none;
  }

  .content {
    position: relative;
    z-index: 2;
    padding: 25px; /* Reduced padding from 35px */
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .back {
    transform: rotateY(180deg);
  }

  /* Typography Styles */
  .header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 30px;
  }

  .label {
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 3px;
  }

  .title {
    font-size: 17px; /* Reduced heading size */
    font-weight:600;
    color: #01014C;
    line-height: 1.4;
    margin-bottom: 20px;
    font-family: 'Syne', sans-serif;
  }

  .problem-desc {
    font-size: 15px;
    line-height: 1.6;
    color: #383d45ff; /* Tailwind gray-600 */
  }

  .hover-indicator {
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    color: #424954ff; /* Tailwind gray-400 */
    transition: color 0.3s;
  }

  .card-outer:hover .hover-indicator {
    color: ${props => props.activeColor};
  }

  /* Back Side Details */
  .impact-header {
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 2px;
    margin-bottom: 25px;
  }

  .impact-list {
    list-style: none;
    padding: 0;
  }

  .impact-list li {
    font-size: 14px;
    color: #374151; /* Tailwind gray-700 */
    margin-bottom: 12px;
    padding-left: 20px;
    position: relative;
  }

  .impact-list li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 10px;
    width: 6px;
    height: 1px;
    background: ${props => props.activeColor};
  }

  .cost-container {
    margin-top: auto;
    padding: 24px;
    border-radius: 20px;
    border-left: 3px solid ${props => props.activeColor};
  }

  .cost-container small {
    display: block;
    font-size: 9px;
    font-weight: 900;
    margin-bottom: 6px;
    letter-spacing: 1px;
  }

  .cost-container p {
    font-size: 13px;
    font-style: italic;
    color: #4b5563; /* Tailwind gray-600 */
    line-height: 1.5;
  }
`;

export default ChallengeCard;